import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface RutaProtegidaProps {
  children: React.ReactNode;
}

const RutaProtegida: React.FC<RutaProtegidaProps> = ({ children }) => {
  const { usuario, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-auth">
        <div className="loading-spinner"></div>
        <p>Verificando sesion...</p>
      </div>
    );
  }

  if (!usuario) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default RutaProtegida;
